import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UsuariosService } from 'src/app/service/usuarios.service';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { LicencasService } from 'src/app/service/licencas.service';
import { AlertService } from 'src/app/service/alert.service';

@Component({
  selector: 'app-escolher-usuario-enviar-token',
  templateUrl: './escolher-usuario-enviar-token.component.html',
  styleUrls: ['./escolher-usuario-enviar-token.component.css']
})
export class EscolherUsuarioEnviarTokenComponent implements OnInit {

  public usuariosDoCliente: any = [];
  public emailsForm = this.formBuilder.group({
    ar_emails: new FormControl([], [Validators.required])
  })

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EscolherUsuarioEnviarTokenComponent>,
    public usuarioService: UsuariosService,
    private formBuilder: FormBuilder,
    private licencaService: LicencasService,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.acharUsuariosComAcessoAoCliente();
  }

  acharUsuariosComAcessoAoCliente(){
    this.usuarioService.listarServiceUsuario(this.data[0].dadosLicencaAdquirida.fk_cliente).subscribe((usuariosDoCliente: any) => {
      this.usuariosDoCliente = usuariosDoCliente;
    })
  }

  enviarTokenParaOsEmails(){
    var dadosParaEnviarParaOEmail = {
      "nomeLicenca": this.data[1],
      "dadosDaLicenca": this.data[0],
      "emails": this.emailsForm.get('ar_emails')?.value
    }
    this.licencaService.enviarParaEmail(dadosParaEnviarParaOEmail).subscribe((repssotaSobreOEmail: any) => {
      this.dialogRef.close();
    },
    (erro) => {
      this.alertService.error(erro);
      this.dialogRef.close();
    })
  }
}
